import type { LocaleMessageBundle } from '../../types'

export const developerInfoMessages: LocaleMessageBundle = {
  vi: {
    'setting.about.title': 'Nhà phát triển',
    'setting.about.subtitle':
      'Thông tin về nhà phát triển và đơn vị sở hữu phần mềm quản lý bán hàng BigSale',
    'setting.about.tagline': 'Phần mềm quản lý bán hàng đa kênh',
    'setting.about.version': 'Phiên bản',
    'setting.about.developerRole': 'Kỹ sư phát triển',
    'setting.about.rights': 'Bảo lưu mọi quyền.',
    'setting.about.contactHint':
      'Liên hệ để được hỗ trợ triển khai, đào tạo và chăm sóc khách hàng.',
    'setting.about.sections.developer': 'Nhà phát triển',
    'setting.about.sections.company': 'Công ty',
    'setting.about.sections.product': 'Sản phẩm',
    'setting.about.fields.developer': 'Người phát triển',
    'setting.about.fields.company': 'Công ty chủ quản',
    'setting.about.fields.phone': 'Số điện thoại',
    'setting.about.fields.email': 'Email',
    'setting.about.fields.website': 'Website',
    'setting.about.fields.address': 'Địa chỉ',
    'setting.about.product.features.pos': 'Bán hàng POS tại quầy và theo bàn',
    'setting.about.product.features.online': 'Kênh bán online và quét mã QR gọi món',
    'setting.about.product.features.inventory':
      'Kho, bảng giá, khuyến mãi và khách hàng thân thiết',
    'setting.about.product.features.reports': 'Báo cáo doanh thu, thu chi theo ca và theo ngày',
  },
  en: {
    'setting.about.title': 'Developer',
    'setting.about.subtitle':
      'Information about the developer and the owner of the BigSale sales management software',
    'setting.about.tagline': 'Multi-channel sales management software',
    'setting.about.version': 'Version',
    'setting.about.developerRole': 'Software developer',
    'setting.about.rights': 'All rights reserved.',
    'setting.about.contactHint': 'Contact us for deployment, training and customer support.',
    'setting.about.sections.developer': 'Developer',
    'setting.about.sections.company': 'Company',
    'setting.about.sections.product': 'Product',
    'setting.about.fields.developer': 'Developed by',
    'setting.about.fields.company': 'Owned by',
    'setting.about.fields.phone': 'Phone',
    'setting.about.fields.email': 'Email',
    'setting.about.fields.website': 'Website',
    'setting.about.fields.address': 'Address',
    'setting.about.product.features.pos': 'Counter and table-based POS sales',
    'setting.about.product.features.online': 'Online sales channel and QR-code ordering',
    'setting.about.product.features.inventory':
      'Inventory, price lists, promotions and customer loyalty',
    'setting.about.product.features.reports': 'Revenue, cash flow, shift and daily reports',
  },
}
